import { createAction } from '@reduxjs/toolkit';
import { INavigateToHashOptions, RoutesType } from './types';

export const routeChangeAction = createAction<string>('routeChange');
export const navigateToAction = createAction<keyof RoutesType>('navigation/navigateTo');
export const navigateToHashAction = createAction<INavigateToHashOptions>('navigation/navigateToHsah');
export const navigateBackAction = createAction<void>('navigation/navigateBack');
export const navigateToExternalAction = createAction<keyof RoutesType>('navigation/navigateToExternal');

